export default "/_next/static/chunks/fonts/WhitneySSm-Black-Pro_Web-7a51a9ba9889a0cc9a8c6038bf914976.woff2";